/**
* @ngdoc component
* @name debug.component:itxDebug
* @description
* This component shows a tool bar in the footer for testing purposes.
*/
(function() {
    'use strict';

    var ItxDebug = {
        controller: ItxDebugCtrl,
        templateUrl: 'debug.component.html'
    };

    angular.module('itxApp.common')
        .component('itxDebug', ItxDebug);

    ItxDebugCtrl.$inject = [
        'DebugModalsService',
        'ItxConfigurationSvc',
        'UserService',
        'CmsConfigSvc',
        'AkamaiDateSvc'
    ];

    function ItxDebugCtrl (
        DebugModalsService,
        ItxConfigurationSvc,
        UserService,
        CmsConfigSvc,
        AkamaiDateSvc
    ) {
        var _this = this;

        _this.$onInit = function () {

            _this.showBar = false;

            if(ItxConfigurationSvc.isDebugActive()){
                _this.options = ItxConfigurationSvc.getDebugOptions();
                _this.showBar = true;
                _this.fontHelperActive = false;
                _this.arabicActive = false;
                _this.modals = DebugModalsService.getModals();

                // Mostramos el tipo de usuario
                _this.printUserType();

                const http = new XMLHttpRequest();
                const url = window.location.origin + '/itxrest/1/oam/store/' + inditex.iStoreJSON.id + '/xconfiguracion?variable=PRICE_DATE';
                http.open('GET', url);
                http.send();
    
                http.onreadystatechange = (e) => {
                    try {
                        const response = JSON.parse(http.response);
                        if (response.value !== null) {
                            _this.priceDate = response.value;
                        }
                    } catch (error) {}
                };
                // Mostramos el tipo de precio
                _this.printPriceType();

            }

        };

        _this.openModal = function(modal){
            DebugModalsService.openModal(modal);
        };

        _this.toggleFontHelper = function(){
            var body = $('body'),
                fontHelperclass= 'helper-font';

            if( body.hasClass(fontHelperclass)) {
                _this.fontHelperActive = false;
                body.removeClass(fontHelperclass);
            } else {
                _this.fontHelperActive = true;
                body.addClass(fontHelperclass);
            }
        };

        _this.toggleArabic = function(){
            var body = $('body');
            var arabicWritingClass = 'is-rtl';
            var borderMarker = 'debug-border';

            if( body.hasClass(arabicWritingClass)) {
                _this.arabicActive = false;
                body.removeClass(arabicWritingClass);
                body.removeClass(borderMarker);
                body.removeAttr("dir");
            } else {
                _this.arabicActive = true;
                body.addClass(arabicWritingClass);
                body.addClass(borderMarker);
                body.attr("dir","rtl");
            }
        }

        _this.getModalName = function(modal) {
            if(modal.alias) {
                return modal.alias;
            }
            if(modal.template){
                return modal.template;
            } else { 
                return modal.templateUrl;
            }
        };

        _this.closeDebug = function() {
            inditex.removeSessionStorage('DebugActive');
            inditex.removeSessionStorage('DebugOptions');
            UserService.resetUserVipType();
            location.reload();
        };

        _this.showProperties = function () {
            _this.options.properties = !_this.options.properties;
            _this.setOptions();
        };

        _this.showTimeTraveler = function () {
            _this.options.timeTraveler = !_this.options.timeTraveler;
            _this.setOptions();
        };

        _this.showProductInfo = function () {
            _this.options.productInfo = !_this.options.productInfo;
            _this.setOptions();
        };

        _this.setOptions = function () {
            ItxConfigurationSvc.setDebugOptions(JSON.stringify(_this.options));
            location.reload();
        };

        /**
         * Función para establecer el usuario como VIP
         */
        _this.addUserVip = function () {
            UserService.setUserIsVip();
            _this.printUserType();
            location.reload();
        };

        /**
         * Función para establecer el usuario como NO VIP
         */
        _this.addUserNoVip = function () {
            UserService.setUserIsNoVip();
            _this.printUserType();
            location.reload();
        };

        /**
         * Función para reestablecer el usuario
         */
        _this.resetUserType = function () {
            UserService.resetUserVipType();
            _this.printUserType();
            location.reload();
        };

        _this.showCategoryIds = function () {
            _this.options.showCategoryIds = !_this.options.showCategoryIds;
            _this.setOptions();
        };

        /**
         * Función para pintar el tipo de usuario
         */
        _this.printUserType = function () {
            
            if(UserService.getUserVipType() == 'true') {

                _this.userType = 'VIP';

            } else if(UserService.getUserVipType() == 'false') {

                _this.userType = 'NO VIP';

            } else {

                _this.userType = 'Default';

            }

        };

        /**
         * Función para pintar el tipo de precio
         */
        _this.printPriceType = function () {
            _this.priceType = 'Default';

            AkamaiDateSvc.getDate().then((localDate) => {
                _this.actualDate = localDate._d;
                return localDate;
            });

            CmsConfigSvc.getProperty('ptc_dates').then((prewarmDates) => {
                if (new Date(prewarmDates.from) < _this.actualDate && new Date(prewarmDates.to) > _this.actualDate) {
                    _this.priceType = 'Prewarm';
                }
            });

            CmsConfigSvc.getProperty('vip_dates').then((vipDates) => {
                if (new Date(vipDates.from) < _this.actualDate && new Date(vipDates.to) > _this.actualDate) {
                    _this.priceType = 'Vip';
                }
            });

            CmsConfigSvc.getProperty('sales_dates').then((salesDates) => {
                if (new Date(salesDates.from) < _this.actualDate && new Date(salesDates.to) > _this.actualDate) {
                    _this.priceType = 'Sales';
                }
            });
        };
    }
})();
